export default {
    days: "дней",
    hours: "часов",
    minutes: "минут",
    seconds: "секунд"
}
